/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Space_Field_Credential_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Paste the API key or token" |
*
* @param {External_Apis_Space_Field_Credential_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_space_field_credential_placeholder = /** @type {((inputs?: External_Apis_Space_Field_Credential_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Space_Field_Credential_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel oder Token einfügen")
	return /** @type {LocalizedString} */ ("Paste the API key or token")
});